export default __webpack_public_path__ + "static/media/151-actions.0452ed00.png";